import React, { useContext } from 'react';

import { MapTo, Utils } from '@adobe/aem-react-editable-components';
import { useQuery } from '@apollo/client';
import { GET_EVENT_BY_AEMID, USER_STATUS_QUERY } from 'Queries/Queries';
import { ParticipantsListContext } from 'context/ParticipantsList';
import { QrScannerContext } from 'context/QrScanner';
import { useCurrentInstaller } from 'hooks/UseCurrentInstaller';
import PropTypes from 'prop-types';
import { withRouter } from 'react-router';

import { EventParticipantsList } from 'components/Event/EventParticipantsList/EventParticipantsList';
import { EventQrScanner } from 'components/Event/EventQrScanner/EventQrScanner';
import { EventRegisterForm } from 'components/Event/EventRegisterForm/EventRegisterForm';
import { HintText } from 'components/HintText/HintText';
import { HINTTEXT_TYPE } from 'components/HintText/HintTextType';
import { LoadingIndicator } from 'components/LoadingIndicator/LoadingIndicator';
import { RenderAemComponent } from 'components/RenderAemComponent/RenderAemComponent';

export const EventDetailPage = ({ id }) => {
  const { list } = useContext(ParticipantsListContext);
  const { qrScannerOpen, setQrScannerOpen } = useContext(QrScannerContext);
  const installer = useCurrentInstaller();
  const { data: userStatusData, loading: loadingStatusData } = useQuery(USER_STATUS_QUERY, {
    fetchPolicy: 'network-only',
  });

  const isEditor = Utils.isInEditor();

  const {
    loading: eventLoading,
    error,
    data,
    refetch,
  } = useQuery(GET_EVENT_BY_AEMID, {
    variables: {
      aemId: id,
    },
    fetchPolicy: 'network-only',
  });

  if (isEditor) {
    return <RenderAemComponent componentProps={{}} name="EventDetailPage" />;
  }

  let realLoading = true;

  if (!loadingStatusData && userStatusData) {
    if (userStatusData.userStatus.iamType === 'EIAM' || list === true) {
      realLoading = eventLoading;
    } else {
      realLoading = eventLoading || installer.isLoading || !installer.installer;
    }
  }

  if (realLoading || !data) return <LoadingIndicator />;

  if (error) {
    console.error('EventDetailPage error:', error);
  }

  const { event } = data;
  if (error) {
    return (
      <HintText type={HINTTEXT_TYPE.ERROR}>
        Es ist ein Fehler aufgetreten, bitte versuchen sie es später erneut.
      </HintText>
    );
  }

  if (list) {
    return <EventParticipantsList event={event} />;
  }

  if (qrScannerOpen) {
    return <EventQrScanner event={event} />;
  }

  return (
    <EventRegisterForm
      event={event}
      userStatusData={userStatusData}
      installer={installer}
      refetchEvent={refetch}
      setQrScannerOpen={setQrScannerOpen}
    />
  );
};
EventDetailPage.propTypes = {
  id: PropTypes.string.isRequired,
};
MapTo('e-fix/components/content/event')(withRouter(EventDetailPage));
